import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'removeTime'
})
export class RemoveTimePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    let str = value;
    return str.split(" ")[0];
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src185846418/src/src/app/pipes/remove-time.pipe.ts